import * as React from 'react';
import {styled} from '@packages/utilities/styled';
import {useCheckbox} from './useCheckbox';
import {type CheckboxProps} from './Checkbox.types';
import {CheckboxCheckmark} from './CheckboxCheckmark';
import {CheckboxInput} from './CheckboxInput';
import {CheckboxLabel} from './CheckboxLabel';

const View = styled('label')(({disabled, style}) => ({
  alignItems: 'relative',
  cursor: disabled ? 'not-allowed' : 'default',
  display: 'flex',
  justifyContent: 'flex-start',
  marginBottom: 0,
  opacity: disabled ? 0.5 : 1,
  position: 'relative',
  userSelect: 'none',
  ...style,
}));

/**
 * @deprecated use `Checkbox` from `@packages/systems/spring` instead
 */
export const Checkbox = React.forwardRef<any, CheckboxProps>((props, ref) => {
  const {checkmarkProps, inputProps, label, labelProps, ...rest} =
    useCheckbox(props);

  return (
    <View data-legacy-ds="Checkbox" {...rest}>
      <CheckboxInput {...inputProps} ref={ref} />
      <CheckboxCheckmark {...checkmarkProps} />
      {label && <CheckboxLabel {...labelProps}>{label}</CheckboxLabel>}
    </View>
  );
});

export default Checkbox;
